/**
 * Sortable Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String}
 */
window.sortableFormatter = function(value, row) {
    if (row.id) {
        return '<i class="fad fa-sort fa-2x sortable" data-id="' + row.id + '"></i>';
    }
};
